<template>
  <div class="rpg-pd-5">
    <div class="rpg-pd-5-10 rpg-bd-b rpg-pr-title">
      <span class="rpg-label">{{ project.客户公司 }}-{{ project.项目名称 }}</span>
      <span class="rpg-gray">（当前项目）</span>
    </div>
    <div class="rpg-pd-5-10 rpg-label">未过保</div>
    <div class="rpg-pd-5-10">
      <label>原因：</label>
      <el-radio v-model="reason" label="淘汰">客户淘汰</el-radio>
      <el-radio v-model="reason" label="放弃">候选人放弃</el-radio>
    </div>
    <div class="rpg-pd-5-10">
      <div>备注：</div>
      <el-input type="textarea" rows="3" v-model="remark" placeholder="原因备注"></el-input>
    </div>
    <div class="rpg-pd-5-10 rpg-text-center">
      <el-button size="mini" type="primary" @click="handleConfirm">提交</el-button>
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
    </div>
  </div>
</template>
<script>
import project_notify from '../constant/project_notify'

export default {
  props: {
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      reason: '放弃',
      remark: '',
    }
  },
  methods: {
    async handleConfirm() {
      const rid = this.radish.rid || this.radish._id
      const pid = this.project._id
      const user = app.user.account
      const time = Date.now()
      const dt = { 未过保: { 原因: this.reason, 备注: this.remark, 时间: time, 顾问: user } }
      const res = await app.service('radish').updateTowork({ rid, pid, data: dt, type: '未过保' })
      if (res.status == 'success') {
        this.onConfirm()
        this.$message.success('操作成功')
        this.remark = ''
        project_notify.sendMessage(rid, pid, '-未过保', '未过保', { 原因: this.reason, 备注: this.remark })
      } else {
        this.$message.error(res.msg)
      }
    },
  },
}
</script>
<style>
@import '../../static/css/progress.css';
</style>
